import axios from 'axios';
import jwt_decode from 'jwt-decode';

import { GET_ERRORS, SET_CURRENT_USER } from './types';
import { API_ENDPOINT } from "../config/constants";
import setAuthToken from '../utils/setAuthToken';

export const registerUser = (userData, history=null) => dispatch => {
    axios.post(API_ENDPOINT+'/tourist', userData)
        .then(res => {
            if (history!==null) { // From Login Page
                history.push({ pathname: '/login', state: { message: 'Tu cuenta ha sido creada con éxito', type: 'success' } });
            } else { // From Booking Page
                let userInfo = { username: userData.username, password: userData.password };
                dispatch(loginUser(userInfo));
            }
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const loginUser = userData => dispatch => {
    axios.post(API_ENDPOINT+'/auth/login', userData)
        .then(res => {
            const { token } = res.data;
            localStorage.setItem('jwtToken', token);
            setAuthToken(token);
            const decoded = jwt_decode(token);
            dispatch(setCurrentUser(decoded));
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const setCurrentUser = decoded => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded
    }
};

export const requestNewPassword = (username, history) => dispatch => {
    axios.post(`${API_ENDPOINT}/auth/reset-password`, {username})
        .then(res => {
            history.push({ pathname: '/login', state: { message: 'Te hemos enviado un email con las instrucciones para restaurar la contraseña', type: 'success' } });
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        )
};

export const addNewPassword = (userData, history) => dispatch => {
    axios.put(`${API_ENDPOINT}/auth/reset-password`, userData)
        .then(res => {
            localStorage.removeItem('jwtToken');
            setAuthToken(false);
            dispatch(setCurrentUser({}));
            history.push({ pathname: '/login', state: { message: 'La nueva contraseña ha sido asignada con éxito', type: 'success' } });
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const logoutUser = history => dispatch => {
    localStorage.removeItem('jwtToken');
    setAuthToken(false);
    dispatch(setCurrentUser({}));
    history.push({ pathname: '/login', state: { message: 'Sesión finalizada exitosamente', type: 'success' } })
};


// WEBPACK FOOTER //
// ./src/actions/authActions.js